import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import {
  Button,
  Card,
  CircularProgress,
  Grid,
  MenuItem,
  Stack,
  Typography,
} from '@mui/material';
import {
  DataGrid,
  gridClasses,
  GridCsvExportMenuItem,
  GridToolbarContainer,
  GridToolbarExportContainer,
} from '@mui/x-data-grid';
import Loading from 'assets/images/loading.png';
import { getApiCall, postApiCall } from 'api/apiService';
import buyerRegistration from 'assets/icons/buyerregistration.svg';
import { statusCard } from 'component/BuyerRegistration/BuyerRegistration.style';
import CardHeaderContainer from 'component/CardHeaderContainer/CardHeaderContainer';
import { BUYER_GETAUCTION, BUYER_SAVEAUCTION } from 'constant/app.config';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { poppins400, poppins500 } from 'theme/common.style';

function Auction({
  profileDetails,
  auctionTable,
  setAuctionBox2,
  auctionBox2,
  setShowUpdateListing,
}) {
  //Table Rows data from countdownTimer and it's add action profile details data
  const [tableData, setTableData] = useState();
  // Table rows data from get api and its a export details
  const [tableRow, setTableRow] = useState([]);
  // trigger state for refresh get auction table data api
  const [trigger, setTrigger] = useState(false);
  const [loading, setLoading] = useState(false);
  // selected Rows in Array
  const [selectionModel, setSelectionModel] = useState([]);
  const params = useParams();
  const propertyId = params?.dashboardId;
  useEffect(() => {
    let data = [];
    if (profileDetails?.BuyerRegisterDetails?.length > 0) {
      profileDetails?.BuyerRegisterDetails?.map((item, index) => {
        let innerdata = {
          id: item?.buyerDetails?.user?.userId,
          Name:
            item?.buyerDetails?.user?.userName +
            item?.buyerDetails?.user?.userSurName,
          MailId: item?.buyerDetails?.userEmail,
          'Mobile Number': item?.buyerDetails?.userMobile,
          'Auction Status': 'Confirmed',
          '66W Status': item?.buyerDetails?.is66Signed == 1 ? 'Yes' : 'No',
          'Number of Offers': item?.buyerDetails?.noOfOffers,
          'Property Rating': item?.buyerDetails?.rating,
          Exp: item?.buyerDetails?.exp,
          Profile: item?.buyerDetails?.profile,
        };
        data.push(innerdata);
      });
    }
    setTableData(data);
  }, [profileDetails]);

  // getting export action table data from api
  const handleGetAuction = () => {
    getApiCall(`${BUYER_GETAUCTION}/${propertyId}`).then((res) => {
      if (res?.data?.status == 1) {
        const userDetails = res?.data?.userDetails;
        let data = [];
        if (userDetails?.length > 0) {
          userDetails.map((item, index) => {
            let innerdata = {
              id: item?.user?.userId,
              Name: item?.user?.userName + item?.user?.userSurName,
              MailId: item?.userEmail,
              'Mobile Number': item?.userMobile,
              'Auction Status': 'Confirmed',
              '66W Status': item?.is66Signed == 1 ? 'Yes' : 'No',
              'Number of Offers': item?.noOfOffers,
              'Property Rating': item?.rating,
              Exp: item?.exp,
              Profile: item?.profile,
            };
            data.push(innerdata);
          });
        }
        setTableRow(data);
      }
    });
  };

  useEffect(() => {
    if (auctionTable == true || trigger == true) {
      handleGetAuction();
    }
  }, [propertyId, trigger]);
  // Table Columns Names

  useEffect(() => {
    if (loading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [loading]);

  const columns = [
    {
      field: 'Name',
      headerName: 'Name',
      width: 150,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'MailId',
      headerName: 'Mail Id',
      width: 250,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'Mobile Number',
      headerName: 'Mobile Number',
      width: 150,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'Auction Status',
      headerName: 'Auction Status',
      width: 150,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: '66W Status',
      headerName: '66W Status',
      width: 130,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'Number of Offers',
      headerName: 'Number of Offers',
      width: 150,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'Property Rating',
      headerName: 'Property Rating',
      width: 150,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'Exp',
      headerName: 'Exp',
      width: 100,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'Profile',
      headerName: 'Profile',
      width: 150,
      headerClassName: 'super-app-theme--header',
    },
  ];

  //Export Button Toolbar
  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{
          justifyContent: 'end',
          padding: '10px 0px 5px 0',
          position: 'absolute',
          top: '-77px',
          right: 0,
        }}
      >
        {/* export button for auction table  */}
        {auctionTable && (
          <GridToolbarExportContainer
            sx={{
              textTransform: 'capitalize',
              fontFamily: 'poppins',
              fontSize: '16px',
              backgroundImage:
                '-webkit-linear-gradient(240.46deg, #6C2AD2 -27.13%, #77CFFE 121.57%)',
            }}
            variant="contained"
            startIcon={<KeyboardDoubleArrowDownIcon />}
          >
            <GridCsvExportMenuItem />
            {/* Download as pdf custom menu item  */}
            <GridPdfExportMenuItem />
          </GridToolbarExportContainer>
        )}
      </GridToolbarContainer>
    );
  }
  // pdf download function
  const GridPdfExportMenuItem = (props) => {
    const { hideMenu } = props;

    return (
      <MenuItem
        sx={{ fontFamily: 'poppins !important' }}
        onClick={() => {
          // Hide the export menu after the export
          hideMenu?.();
        }}
      >
        Download as PDF
      </MenuItem>
    );
  };

  // selected rows handle api function
  const handleSelectionApi = () => {
    if (selectionModel.length) {
      // convert to object
      const result = selectionModel.map((item) => {
        return { buyerId: item };
      });
      const input = {
        propertyId: profileDetails?.PropertyDetails?.property?.propertyId,
        buyerList: [...result],
      };
      setLoading(true);
      // post api call
      postApiCall(BUYER_SAVEAUCTION, input)
        .then((res) => {
          if (res?.data?.status == 1) {
            setTrigger(!trigger);
            setLoading(false);
            // selected rows reset
            setSelectionModel([]);
            Swal.fire({
              title: res?.data?.heading ? res?.data?.heading : 'Success',
              text: res?.data?.message,
              showDenyButton: false,
              showCancelButton: false,
              icon: 'success',
              confirmButtonText: 'Close',
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                // close dialog state
                if (auctionBox2) {
                  setAuctionBox2(false);
                  if (typeof setShowUpdateListing === 'function') {
                    setShowUpdateListing(false);
                  }
                }
              } else if (result.isDenied) {
                return;
              }
            });
          } else {
            setLoading(false);
            Swal.fire({
              title: res?.data?.heading ? res?.data?.heading : 'Error',
              text: res?.data?.message,
              showDenyButton: false,
              showCancelButton: false,
              icon: 'error',
              confirmButtonText: 'Close',
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                // close dialog state
                if (auctionBox2) {
                  setAuctionBox2(false);
                  if (typeof setShowUpdateListing === 'function') {
                    setShowUpdateListing(false);
                  }
                }
              } else if (result.isDenied) {
                return;
              }
            });
          }
        })
        .catch(() => setLoading(false));
    }
  };
  //custom checkbox component
  const CustomCheckbox = (props) => {
    return <input {...props} type="checkbox" />;
  };
  return (
    <Card
      variant="outlined"
      sx={statusCard}
      style={{
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'hidden',
        border: !auctionTable && 'none',
        margin: 0,
        paddingBottom: !auctionTable && 0,
      }}
    >
      <Stack
        direction={'column'}
        gap={3}
        style={{
          alignItems: 'center',
          overflowX: 'scroll',
        }}
      >
        {auctionTable && (
          <Grid sx={{ display: 'flex', justifyContent: 'left', width: '100%' }}>
            <CardHeaderContainer
              title="Buyer Auction Table"
              icon={buyerRegistration}
            />
          </Grid>
        )}

        {tableData?.length > 0 && (
          <Typography sx={{ width: '100%' }}>
            {/* <DataGrid
              sx={{
                // table cell  selection
                [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]:
                  {
                    outline: 'none',
                  },
                // table header cell  selection
                [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]:
                  {
                    outline: 'none',
                  },
                [`& .${gridClasses.cellContent}`]: {
                  ...poppins400,
                  fontSize: '12px',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  color: '#112347',
                },
                [`& .super-app-theme--header`]: {
                  fontSize: '10px',
                  fontWeight: 400,
                  fontFamily: 'poppins !importent',
                  color: '#666666',
                },
                fontFamily: 'poppins !important',
                width: '100%',
                height: '100%',
              }}
              rows={!auctionTable ? tableData : tableRow}
              columns={columns}
              checkboxSelection
              selectionModel={selectionModel}
              onRowSelectionModelChange={(val) => setSelectionModel(val)}
              // pageSize={10}
              slots={{
                toolbar: CustomToolbar,
                baseCheckbox: (props) => (
                  <CustomCheckbox {...props} style={{ color: '#6C2AD2' }} />
                ),
              }}
              // autoPageSize
            /> */}

            <DataGrid
              sx={{
                [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]:
                  {
                    outline: 'none',
                  },
                [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]:
                  {
                    outline: 'none',
                  },
                [`& .${gridClasses.cellContent}`]: {
                  ...poppins400,
                  fontSize: '12px',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  color: '#112347',
                },
                [`& .super-app-theme--header`]: {
                  fontSize: '10px',
                  fontWeight: 400,
                  fontFamily: 'poppins !importent',
                  color: '#666666',
                },
                fontFamily: 'poppins !important',
                width: '100%',
                height: '100%',
              }}
              rows={!auctionTable ? tableData : tableRow}
              columns={columns}
              checkboxSelection
              selectionModel={selectionModel}
              onRowSelectionModelChange={(val) => setSelectionModel(val)}
              slots={{
                toolbar: CustomToolbar,
                baseCheckbox: (props) => (
                  <CustomCheckbox {...props} style={{ color: '#6C2AD2' }} />
                ),
              }}
              initialState={{
                pagination: {
                  paginationModel: {
                    page: 0,
                    pageSize: 10,
                  },
                },
              }}
              pageSizeOptions={[10]}
              hideFooter={
                (!auctionTable ? tableData?.length : tableRow?.length) <= 10
              }
              hideFooterPagination={
                (!auctionTable ? tableData?.length : tableRow?.length) <= 10
              }
            />
          </Typography>
        )}
      </Stack>

      {/* add Auction button  */}
      {/* if selected rows length true and confirmation popup is true to  button displayed  */}
      {selectionModel.length && !auctionTable ? (
        <Stack
          direction={'row'}
          justifyContent={'end'}
          alignItems={'center'}
          mt={3}
          spacing={2}
        >
          <Button
            variant="outlined"
            sx={{
              ...poppins400,
              fontSize: '14px',
              bgcolor: '#fff',
              borderRadius: '8px',
              borderColor: '#1123471A',
              textTransform: 'none',
              color: '#666666',
              '&:hover': {
                bgcolor: '#fff',
                borderColor: '#1123471A',
              },
            }}
            onClick={() => {
              if (auctionBox2) {
                setAuctionBox2(false);
                if (typeof setShowUpdateListing === 'function') {
                  setShowUpdateListing(false);
                }
              }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSelectionApi}
            variant="contained"
            disabled={loading}
            sx={{
              fontFamily: 'poppins !important',
              textTransform: 'capitalize',
              backgroundImage:
                'linear-gradient(140.46deg, #6C2AD2 -27.13%, #77CFFE 121.57%)',
              color: '#fff !important',
            }}
            size="medium"
          >
            Add Auction
          </Button>
          {loading && (
            <img
              alt="Logo"
              src={Loading}
              className="loaderImage"
              style={{ height: '40px', width: '40px' }}
            />
          )}
        </Stack>
      ) : (
        ''
      )}
    </Card>
  );
}

export default Auction;
